var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.50004L10 12.5L15 7.5",
    stroke: "#4E4E4E",
    strokeWidth: 1.5,
    strokeMiterlimit: 16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownBlack);
export default __webpack_public_path__ + "static/media/arrow-down-black.a7f595b718ad093a76f3c3aff417447d.svg";
export { ForwardRef as ReactComponent };